import { render, staticRenderFns } from "./salesBigDeliveryPlace.vue?vue&type=template&id=04b99573&scoped=true&"
import script from "./salesBigDeliveryPlace.vue?vue&type=script&lang=js&"
export * from "./salesBigDeliveryPlace.vue?vue&type=script&lang=js&"
import style0 from "./salesBigDeliveryPlace.vue?vue&type=style&index=0&id=04b99573&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b99573",
  null
  
)

export default component.exports